export default {
    data(){
        return{



        }
    },
    mounted(){},
    methods:{
        handelJump(path){
            console.log("口服卡佛破");
            this.$router.push(path)
        }
    }
}